function PuertoRico({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1937)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C10.7655 0 6.11834 2.51394 3.19934 6.4H28.8007C25.8817 2.51394 21.2345 0 16 0Z" fill="#D80027"/>
  <path d="M16 31.9996C21.2345 31.9996 25.8817 29.4857 28.8007 25.5996H3.19934C6.11834 29.4857 10.7655 31.9996 16 31.9996Z" fill="#D80027"/>
  <path d="M0 16.0008C0 17.0967 0.1105 18.1668 0.320437 19.2008H31.6797C31.8896 18.1668 32 17.0967 32 16.0008C32 14.9048 31.8895 13.8347 31.6796 12.8008H0.320437C0.1105 13.8347 0 14.9048 0 16.0008H0Z" fill="#D80027"/>
  <path d="M4.68628 4.68555C-1.56209 10.9339 -1.56209 21.0646 4.68628 27.313C7.26834 24.731 9.75165 22.2477 16 15.9993L4.68628 4.68555Z" fill="#0052B4"/>
  <path d="M6.47561 11.8262L7.51154 15.0147H10.8644L8.15204 16.9854L9.18792 20.174L6.47561 18.2034L3.76317 20.174L4.79929 16.9854L2.08691 15.0147H5.43954L6.47561 11.8262Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default PuertoRico;
